import { useEffect, useRef } from 'react'

export default function TrustPilot() {
  const ref = useRef(null)
  useEffect(() => {
    if(window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])

  return (<div className='trust-pilot text-center'>
    <div
      ref={ref}
      style={{ width: '300px' }}
      data-locale='en-US'
      data-template-id='53aa8912dec7e10d38f59f36'
      data-businessunit-id='55eeddbb0000ff00058313b3'
      data-style-height='140px'
      data-style-width='100%'
      data-theme='light'
      data-stars='5'
      data-schema-type='Organization'
    >
      <a
        href='https://www.trustpilot.com/review/travel.padi.com'
        target='_blank'
      >
        Trustpilot
      </a>
    </div>
  </div>)
}
